const selector = {
  modal: document.querySelector('.js-size-modal'),
  modalOpen: document.querySelector('.js-modal-toggle'),
  modalClose: document.querySelector('.js-modal-close')
}

let modalOpener = () => {
  if (selector.modal.classList.contains('close')){
    selector.modal.classList.replace('close', 'open');
  }else{
    selector.modal.classList.replace('open', 'close');
  }

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      selector.modal.classList.replace('open', 'close');
    }
  });
}

selector.modalOpen.addEventListener('click', modalOpener.bind(this));
selector.modalClose.addEventListener('click', modalOpener.bind(this));